
import { memo } from "react";

import { IonCol, IonGrid, IonRow, } from "@ionic/react";

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import PhoneInput from 'react-phone-input-2';
import es from 'react-phone-input-2/lang/es.json'
import 'react-phone-input-2/lib/material.css';
import { TextField } from "@material-ui/core";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        button: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        actionsContainer: {
            marginBottom: theme.spacing(2),
        },
        resetContainer: {
            padding: theme.spacing(3),
        },
    }),
);


const DatosFacturacion = ({
    handleNext,
    handleBack,
    formik: {
        errors,
        touched,
        setTouched,
        setFieldValue,
        values,
        handleChange,
    } }: any) => {

    //console.log({ errors, values });

    const classes = useStyles();

    return (
        <>
            <IonGrid className="ion-padding-none">
                <IonRow>

                    <IonCol className="ion-text-center" size="12">
                        <img
                            src={process.env.PUBLIC_URL + '/assets/img/steps/bill.png'}
                            height={120}
                            alt=""
                        />
                    </IonCol>

                    <IonCol sizeXl="6" sizeMd="6" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Nombre(s) al que va dirigida la factura"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.nombre"}
                            name={"Escuela.DatosFacturacion.nombre"}
                            value={values.Escuela.DatosFacturacion.nombre}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        nombre: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.nombre && errors?.Escuela?.DatosFacturacion?.nombre}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>


                    <IonCol sizeXl="6" sizeMd="6" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Apellidos al que va dirigida la factura"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.apellidos"}
                            name={"Escuela.DatosFacturacion.apellidos"}
                            value={values.Escuela.DatosFacturacion.apellidos}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        apellidos: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.apellidos && errors?.Escuela?.DatosFacturacion?.apellidos}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="6" sizeMd="6" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Nombre de la razón social (Física/Moral)"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.razons"}
                            name={"Escuela.DatosFacturacion.razons"}
                            value={values.Escuela.DatosFacturacion.razons}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        razons: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.razons && errors?.Escuela?.DatosFacturacion?.razons}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="6" sizeMd="6" sizeSm="12" sizeXs="12">
                        <TextField
                            label="RFC"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.rfc"}
                            name={"Escuela.DatosFacturacion.rfc"}
                            value={values.Escuela.DatosFacturacion.rfc}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        rfc: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.rfc && errors?.Escuela?.DatosFacturacion?.rfc}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                            inputProps={{
                                maxLength: 13
                            }}
                        />
                    </IonCol>

                    <IonCol sizeXl="8" sizeMd="8" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Correo de facturación"
                            type="email"
                            inputMode="email"
                            id={"Escuela.DatosFacturacion.email"}
                            name={"Escuela.DatosFacturacion.email"}
                            value={values.Escuela.DatosFacturacion.email}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        email: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.email && errors?.Escuela?.DatosFacturacion?.email}
                            required
                            variant="outlined"
                            size="medium"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="4" sizeMd="4" sizeSm="12" sizeXs="12">
                        <PhoneInput
                            inputProps={{
                                name: 'Teléfono',
                                required: true,
                                autoFocus: true
                            }}
                            localization={es}
                            country={'mx'}
                            enableSearch={true}
                            placeholder="Teléfono"
                            specialLabel="Teléfono"
                            searchPlaceholder="Buscar país"
                            searchNotFound="Sin resultados"
                            value={values.Escuela.DatosFacturacion.telefono}
                            onChange={(e: string) => setFieldValue("Escuela.DatosFacturacion.telefono", e)}
                            regions={['america']}
                            onlyCountries={['mx']}
                            autocompleteSearch={true}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        telefono: true
                                    }
                                }
                            })}
                            isValid={(value, country: any) => {
                                if (value.match(/12345/)) {
                                    return 'Numero invalido: ' + value + ', ' + country.name;
                                } else if (value.match(/1234/)) {
                                    return false;
                                } else {
                                    return true;
                                }
                            }}
                        />
                    </IonCol>

                    <IonCol sizeXl="4" sizeMd="4" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Calle"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.calle"}
                            name={"Escuela.DatosFacturacion.calle"}
                            value={values.Escuela.DatosFacturacion.calle}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        calle: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.calle && errors?.Escuela?.DatosFacturacion?.calle}
                            required
                            variant="outlined"
                            margin="normal"
                            size="medium"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="2" sizeMd="2" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Número"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.numero_exterior"}
                            name={"Escuela.DatosFacturacion.numero_exterior"}
                            value={values.Escuela.DatosFacturacion.numero_exterior}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        numero_exterior: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.numero_exterior && errors?.Escuela?.DatosFacturacion?.numero_exterior}
                            required
                            variant="outlined"
                            margin="normal"
                            size="medium"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="4" sizeMd="4" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Colonia"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.colonia"}
                            name={"Escuela.DatosFacturacion.colonia"}
                            value={values.Escuela.DatosFacturacion.colonia}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        colonia: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.colonia && errors?.Escuela?.DatosFacturacion?.colonia}
                            required
                            variant="outlined"
                            margin="normal"
                            size="medium"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="2" sizeMd="2" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Código postal"
                            type="text"
                            inputMode="numeric"
                            id={"Escuela.DatosFacturacion.codpos"}
                            name={"Escuela.DatosFacturacion.codpos"}
                            value={values.Escuela.DatosFacturacion.codpos}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        codpos: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.codpos && errors?.Escuela?.DatosFacturacion?.codpos}
                            required
                            variant="outlined"
                            margin="normal"
                            size="medium"
                            fullWidth
                            inputProps={{
                                maxLength: 5,
                            }}
                        />
                    </IonCol>

                    <IonCol sizeXl="6" sizeMd="6" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Ciudad"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.ciudad"}
                            name={"Escuela.DatosFacturacion.ciudad"}
                            value={values.Escuela.DatosFacturacion.ciudad}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        ciudad: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.ciudad && errors?.Escuela?.DatosFacturacion?.ciudad}
                            required
                            variant="outlined"
                            margin="normal"
                            size="medium"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="6" sizeMd="6" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Estado"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosFacturacion.estado"}
                            name={"Escuela.DatosFacturacion.estado"}
                            value={values.Escuela.DatosFacturacion.estado}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosFacturacion,
                                    DatosFacturacion: {
                                        ...touched?.Escuela?.DatosFacturacion,
                                        estado: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosFacturacion?.estado && errors?.Escuela?.DatosFacturacion?.estado}
                            required
                            variant="outlined"
                            margin="normal"
                            size="medium"
                            fullWidth
                        />
                    </IonCol>


                    <div className={classes.actionsContainer}>
                        <div className="ion-padding">
                            <Button
                                onClick={handleBack}
                                className={classes.button}
                            >
                                Anterior
                            </Button>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleNext}
                                className={classes.button}
                                // || !touched.Escuela.hasOwnProperty('DatosFacturacion')
                                disabled={errors?.Escuela?.hasOwnProperty('DatosFacturacion')}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </div>

                </IonRow>

            </IonGrid>

        </>

    );
};

export default memo(DatosFacturacion);